import "./AboutMain.scss";
import React, { useEffect } from "react";
import AboutTop from "./AboutTop";
import AboutHighlights from "./AboutHighlights";
import AboutDepartments from "./AboutDepartments";

const AboutMain = () => {

    useEffect(() => {
    window.scrollTo(0, 0);
    }, []);


//==========================================    
return (
    <div className="aboutMain">
    <AboutTop />
    <AboutHighlights />
    <AboutDepartments />
    </div>
);
};

export default AboutMain;